export default "__VITE_ASSET__124a5a55__"